export default __webpack_public_path__ + "static/media/ic-big.2e9bff91.png";